// extracted by mini-css-extract-plugin
export default {"OutterDIV":"LoginForm_OutterDIV__d7Knv","row":"LoginForm_row__Lmtd0","contenedorwhoami":"LoginForm_contenedorwhoami__8cHTL","whoamiIMGDIV":"LoginForm_whoamiIMGDIV__h7MS9"};